import React from "react";
import useApp from "../../store/app/appContext";
import PageWrapper from '../../containers/app/PageWrapper';
import LogoWithCaptionWhite from "../../components/Logos/LogoBlue";
import CopyrightCaption from "../../components/App/CopyrightCaption";
import { LOGO_SIZES } from "../../config";
import UpdatePasswordForm from '../../containers/account/UpdatePasswordForm';
import { useHistory } from "react-router";


function UpdatePasswordPage() {
  const { appState: { user }} = useApp();
  const history = useHistory();

  if (!user) return '';
  if (!user._id) return '';

  const captionStyle = {
    minWidth: '45%'
  }

  const style = {
    backgroundColor: 'white'
  }

  if (!user.temp_password) history.push('/dashboard');
  
  return (
    <PageWrapper style={style} className="xl:h-screen xl:bg-d-shape xl:bg-left xl:py-8 xl:px-12 xl:bg-xauto-y100 bg-mobile bg-top py-6 px-8 w-full bg-no-repeat flex flex-col">
      <div className="flex flex-row items-center justify-center xl:justify-start">
        <LogoWithCaptionWhite className={LOGO_SIZES.CAPTION.dynamic}/>
      </div>
      <div className="flex-grow flex items-center xl:flex-row flex-col py-8 xl:p-0">
        <div className='flex flex-col min-h-170 xl:min-h-0' style={captionStyle}>
          <span className='text-white md:text-4xl text-xl'>Welcome to the <strong>XiViX Care Portal</strong></span>
          <span className='text-white mt-2'>Log in to view and manage all of your ongoing XiViX Treatments</span>
        </div>
        <div className='w-full flex 2xl:justify-center mt-6 xl:mt-0 2xl:mr-0 xl:mr-12 xl:justify-end justify-center xl:min-w-0'>
          <UpdatePasswordForm />
        </div>
      </div>
      <div className='flex justify-center xl:justify-end xl:mt-8'>
        <CopyrightCaption/>
      </div>
    </PageWrapper>
  );
}

export default UpdatePasswordPage;
